export const PAYMENT_RECEIPT_FIELDS = `
    id
    change
    createdAt
    method
    received
    note
`;
